// Derives a tonal badge style from a SINGLE stored hex color.
// background = light tint (~12%), text = darkened shade of the same hue,
// border = mid tint. One color drives all three — no separate bg/text inputs.

const SLATE_FALLBACK = { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" };

function hexToRgb(hex) {
  if (!hex || typeof hex !== "string") return null;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return null;
  const num = parseInt(h, 16);
  if (Number.isNaN(num)) return null;
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

// Move channel `c` toward `target` by `ratio` (0..1).
function mix(c, target, ratio) {
  return Math.round(c + (target - c) * ratio);
}

function rgb({ r, g, b }) {
  return `rgb(${r}, ${g}, ${b})`;
}

export function badgeStyle(hex) {
  const c = hexToRgb(hex);
  if (!c) return SLATE_FALLBACK;
  return {
    // ~12% color over white
    backgroundColor: rgb({ r: mix(c.r, 255, 0.88), g: mix(c.g, 255, 0.88), b: mix(c.b, 255, 0.88) }),
    // darkened shade of the same family for contrast
    color: rgb({ r: mix(c.r, 0, 0.35), g: mix(c.g, 0, 0.35), b: mix(c.b, 0, 0.35) }),
    // mid tint border
    borderColor: rgb({ r: mix(c.r, 255, 0.72), g: mix(c.g, 255, 0.72), b: mix(c.b, 255, 0.72) }),
  };
}

// A more saturated accent (for e.g. Kanban card top borders). Falls back to slate.
export function accentColor(hex) {
  return hexToRgb(hex) ? hex : "#94a3b8";
}
